import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService } from '@examdojo/supabase';
import { BehaviorSubject, finalize, from, map, Observable, tap } from 'rxjs';
import { mapStudentAssignmentToUIModel, StudentAssignmentUIModel } from './student-assignment.model';

// TODO: Refactor to use store + query instead of BehaviorSubjects
@Injectable()
export class StudentAssignmentService {
  constructor(private readonly supabase: ExamdojoSupabaseService) {}

  private readonly data$$ = new BehaviorSubject<StudentAssignmentUIModel[]>([]);
  private readonly loading$$ = new BehaviorSubject<boolean>(false);

  readonly data$ = this.data$$.asObservable();
  readonly loading$ = this.loading$$.asObservable();

  fetch(classId: string, studentId: string): Observable<StudentAssignmentUIModel[]> {
    this.data$$.next([]);
    this.loading$$.next(true);

    return from(
      this.supabase.client
        .schema('classroom')
        .from('teacher_student_assignments_list')
        .select('*')
        .eq('class_id', classId)
        .eq('student_id', studentId)
        .throwOnError()
        .then((response) => response.data ?? []),
    ).pipe(
      map((rows) => rows.map(mapStudentAssignmentToUIModel)),
      tap((items) => this.data$$.next(items)),
      finalize(() => this.loading$$.next(false)),
    );
  }

  reset(): void {
    this.data$$.next([]);
    this.loading$$.next(false);
  }
}
